module.exports = "/_next/static/images/AicpaSocBadge@2x-0e214cd1ae852ca82ef2cd8dbb873f47.png";